import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwExpressionService, DwFormContextMode, DwFormActionInterceptor, 
         DwMetaDataFormApi, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, 
         DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken,
         DwActionPreference, DwFormActionConfig, DwFormActionInterceptResult, DwFormActionKeys,
         DwEventService, DwConfigServiceToken, DwOrmDataService, DwConfigService } from '@devwareapps/devware-cap';
import { debounceTime } from 'rxjs/operators';
import { AppMetaDataItemNames, AppMetaDataLookups, FlightSchoolEntity, RoSchoolPaymentMethodEntity,
         PaymentMethodEntity } 
   from '../../../../meta-data/app-meta-data.service';
import { AddPaymentEvents } from 'src/app/features/payments/components/add-payment/payments-add-payment.component';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { PaymentsRepositoryService } from "src/app/features/payments/services/payments-repository.service";
import { BillingDetailsContext } from '../../models/billings-details.model';
import { map, mergeMap } from 'rxjs/operators';

@DwComponent({
    name: 'School Billing Details UX Util',
    key: 'billingUxUtil',
    componentType: DwComponentType.formSection,
    isGlobal: false,
    parentItemName: AppMetaDataItemNames.FlightSchool,
})
@Component({
    selector: 'app-billing-ux-util',
    template: ` `
})
export class SchoolBillingDetailsUtilComponent extends DwSectionBaseComponent implements OnDestroy {
    formApi: DwMetaDataFormApi;
    originalPms: PaymentMethodEntity[] = [];
    paymentsApi: string;
    defaultCard: number;
    payments : RoSchoolPaymentMethodEntity[] = undefined;

    constructor(
        dwExpressionService: DwExpressionService,
        private http: HttpClient,
        protected dwUiConfigRegistryService: DwUiConfigRegistryService,
        @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
        @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
        private paymentsRepoSvc: PaymentsRepositoryService,
        private dwFormStateService: DwMetaDataFormStateService,
        private dwEventService: DwEventService,
        @Inject(DwConfigServiceToken) private configService: DwConfigService
    ) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.formApi = this.dwFormStateService.state.formApi;
        this.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/Payments`;
    }
    ngOnInit(): void {
        // this.http.get<UpdateProfitSharing>(`${this.paymentsApi}/profit-sharing-update`)
        //         .subscribe(r => {
        //             if (r.updates == true)
        //                 this.updatePayments();
        //         });
    }

    ngOnDestroy(): void {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    
    setupComponentComplete() {
        this.runAfterFormDataLoaded(() => this.setupSubscriptions());
        this.dwFormStateService.addActionInterceptor(this.getFormActionInterceptor());
    }
    updateOriginals() : Observable<PaymentMethodEntity[]>{
        return this.paymentsRepoSvc.getPaymentMethods()
            .pipe(mergeMap(pms => {
                this.originalPms = pms;
                return of(this.originalPms);
            }))
    }
    private setupSubscriptions() {
        const school = this.formApi.getFormData<FlightSchoolEntity>();
        this.handleUpdate(school.RoSchoolPaymentMethod || []);
        this.updateOriginals().subscribe();

        const paymentMethodsControl = this.formApi.formGroup.get('RoSchoolPaymentMethod');

        if (paymentMethodsControl) {
            this.subscriptions.push(
                paymentMethodsControl.valueChanges
                    .pipe(debounceTime(200))
                    .subscribe(paymentMethods => this.handleUpdate(paymentMethods || [])));
        }
        
        this.subscriptions.push(
                    this.dwEventService
                        .getEventData<any>(AddPaymentEvents.AddSchoolPayment)
                        .subscribe(ro => this.updatePayments(ro))
                  );
    }

    updatePayments(ro: any = undefined){
        this.updateOriginals().subscribe(() => {
            const school = this.formApi.getFormData<FlightSchoolEntity>();
            const ros = [...(school.RoSchoolPaymentMethod || [])];

            if (ro != undefined) {
                ros.push(ro);
            }

            let updates = { RoSchoolPaymentMethod : ros }
            this.formApi.patchFormData(updates);
        });
    }
    getFormActionInterceptor(): DwFormActionInterceptor {
        const formStateService = this.dwFormStateService;
        const interceptor: DwFormActionInterceptor = {
          interceptorName: 'billing-details-card-only-interceptor',
          onBeforeAction: (actionPref: DwActionPreference<DwFormActionConfig>, actionConfig: any) => {
            const saveNicknames = actionPref.actionKey == DwFormActionKeys.formSave 
                                && actionPref.actionDisplay.includes("Nick");
            if (saveNicknames){
                this.originalPms.forEach(p => {
                    const card = this.getCurrentRoPayment(p.PaymentMethodId);
                    p.DisplayName = card.Displayname;
                });
                
                this.paymentsRepoSvc.savePaymentMethods(this.originalPms)
                    .subscribe(r => {
                        this.updatePayments();
                        this.formApi.patchVariableContext<BillingDetailsContext>({ CardChange: false });
                    });
    
            }
            const result: DwFormActionInterceptResult = { abort: saveNicknames }
            return of(result);
          }
        }
        return interceptor;
    }
    getCurrentRoPayment(paymentMethodId: number) 
        : RoSchoolPaymentMethodEntity {
        const school = this.formApi.getFormData<FlightSchoolEntity>();
        return school.RoSchoolPaymentMethod.find(c => c.PaymentMethodId == paymentMethodId);
    }

    handleUpdate(cards: RoSchoolPaymentMethodEntity[]) {
        if (this.originalPms.length > 0){
            const deleted = this.originalPms
                                .filter(o => cards.find(c => c.PaymentMethodId == o.PaymentMethodId) == null);
            if (deleted.length > 0)
                deleted.forEach(p => this.paymentsRepoSvc.deletePaymentMethod(p).subscribe());
        }

        const isDef = cards.filter(p => p.IsDefault == true);
        if (this.defaultCard > 0 && isDef.length > 1)
            isDef.find(p => p.PaymentMethodId == this.defaultCard).IsDefault = false;
        
        this.payments = cards;
        this.defaultCard = this.payments.find(p => p.IsDefault == true)?.PaymentMethodId;

        const cardChanges = this.originalPms.filter(rp => 
        {
            const card = this.getCurrentRoPayment(rp.PaymentMethodId);
            return card != undefined && card.Displayname != rp.DisplayName;
        });
        this.formApi.patchVariableContext<BillingDetailsContext>(
            { CardChange: cardChanges.length > 0 });
    }

}
export interface UpdateProfitSharing {
    success?: boolean,
    updates?: boolean,
    enabled?: boolean
}
